export function isLoggedIn (state) {
  return !!state.token
}

export function getToken (state) {
  return state.token
}

export function getInitSearch (state) {
  return state.initSearch
}

export function currentUserEmail (state) {
  return state.user.email
}

export function idEntreprise (state) {
  return state.idEntreprise
}

export function idPlateforme (state) {
  return state.idPlateforme
}

export function insideIframe (state) {
  return state.insideIframe
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js